import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import {
  isValid,
  REQUIRED,
  validate,
} from "../../utils/Validation";


export default function EditStyle({ selected, onClose, onSave }) {
  const [style, setStyle] = useState({
    nameBr: "",
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setStyle(selected);
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
  }, [selected]);

  const clear = () => {
    setStyle({
      nameBr: "",
    });
    setErrors({});
    setSubmitting(false);
  };

  const save = async () => {
    setSubmitting(true);
    const rules = {
      nameBr: REQUIRED,
    };
    const errors = await validate(rules, style);
    if (isValid(errors)) {
      onSave(style);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={style?.id ? "Editar Estilo" : "Novo Estilo"}
      Action={<Button disabled={submitting} submitting={submitting} onClick={() => save()}>Cadastrar</Button>}
    >
      <TextField
        className="mb-5"
        placeholder="Insira um nome"
        value={style}
        field="nameBr"
        update={setStyle}
        errors={errors}
      />
      <div className="h-20" />
    </Modal>
  );
}
